var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import * as FilterOptionFactory from '../../../classes/definitions/product/filterOption';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import filterOptionSchema from "../../../schemas/filterOptionSchema";
import Input from '../../UI/Input/Input';
var FilterOptionForm = /** @class */ (function (_super) {
    __extends(FilterOptionForm, _super);
    function FilterOptionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.productId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(filterOptionSchema),
            formIsValid: false
        };
        _this.getFilterTypes = function () {
            _this.api.getFilterTypes(_this.productId)
                .then(function (response) {
                _this.setFilterTypesDropdown(_.get(response, 'data.filter_types', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка с извличане на типовете филтри';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setFilterTypesDropdown = function (types) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig['filter_type']);
            updatedFormElement.elementConfig.options = [];
            for (var key in types) {
                if (Object.prototype.hasOwnProperty.call(types, key)) {
                    // const type = types[key];
                    updatedFormElement.elementConfig.options.push({
                        label: NotosService.formatFilterTypes(key),
                        value: key
                    });
                }
            }
            _this.setState({ formConfig: updatedFormConfig });
            _this.editId = _.get(_this.props, 'match.params.optionId', '-1');
            if (_this.editId !== '-1') {
                _this.getFilterOption(_this.productId, _this.editId);
            }
        };
        _this.getFilterOption = function (productId, filterOptionId) {
            _this.api.getFilterOption(productId, filterOptionId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на филтър';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var filterOption = FilterOptionFactory.createFilterOption(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'value.value', filterOption.Value);
            _.set(updatedFormConfig, 'value.touched', true);
            _.set(updatedFormConfig, 'value.valid', true);
            _.set(updatedFormConfig, 'en_value.value', filterOption.Envalue);
            _.set(updatedFormConfig, 'en_value.touched', true);
            _.set(updatedFormConfig, 'en_value.valid', true);
            _.set(updatedFormConfig, 'filter_type.value', filterOption.FilterType);
            _.set(updatedFormConfig, 'filter_type.touched', true);
            _.set(updatedFormConfig, 'filter_type.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig)
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig)
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedFilterOption = FilterOptionFactory.createFilterOption({
                value: _.get(formData, 'value.value', ''),
                en_value: _.get(formData, 'en_value.value', ''),
                filter_type: _.get(formData, 'filter_type.value', ''),
            });
            var actionMethod = _this.editId === '-1' ? _this.api.createFilterOption : _this.api.updateFilterOption;
            actionMethod(submittedFilterOption, _this.productId, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toFilterOptionsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на филтър';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toFilterOptionsPage = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.productId + AppRoutes.filterOptions.path);
        };
        return _this;
    }
    FilterOptionForm.prototype.componentDidMount = function () {
        this.productId = _.get(this.props, 'match.params.id', '-1');
        this.getFilterTypes();
    };
    FilterOptionForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        }));
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toFilterOptionsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            actionBtns));
    };
    return FilterOptionForm;
}(React.Component));
// @ts-ignore
export default withRouter(FilterOptionForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/FilterOptions/FilterOptionForm/FilterOptionForm.tsx
// module id = 352
// module chunks = 0